import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DashboardFilterOptions } from '../../services/api';

interface FiltersState {
  filterOptions: DashboardFilterOptions | null;
  loading: boolean;
  error: string | null;
  currentFilters: {
    selectedMonth?: number[];
    selectedYear?: number[];
    selectedLOB?: string[];
    selectedProducts?: string[];
    selectedSubProducts?: string[];
    selectedChannels?: string[];
    selectedSubChannels?: string[];
    selectedRegion?: string[];
  };
}

const initialState: FiltersState = {
  filterOptions: null,
  loading: false,
  error: null,
  currentFilters: {}
};

const filtersSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    fetchFilterOptionsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    setFilterOptions: (state, action: PayloadAction<DashboardFilterOptions>) => {
      state.loading = false;
      state.filterOptions = action.payload;
    },
    setFilterOptionsError: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    setCurrentFilters: (state, action: PayloadAction<FiltersState['currentFilters']>) => {
      state.currentFilters = action.payload;
    },
    // These actions are used by dashboardInitializationEpics.ts
    initializeDashboardRequested: (state, action: PayloadAction<any>) => {
      state.loading = true;
      state.error = null;
    },
    initializeDashboardSucceeded: (state, action: PayloadAction<{
      filterOptions: DashboardFilterOptions;
      autoSelectedFilters: any;
    }>) => {
      state.loading = false;
      state.filterOptions = action.payload.filterOptions;
      state.currentFilters = action.payload.autoSelectedFilters;
    },
    initializeDashboardFailed: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    }
  }
});

export const {
  fetchFilterOptionsStart,
  setFilterOptions,
  setFilterOptionsError,
  setCurrentFilters,
  initializeDashboardRequested,
  initializeDashboardSucceeded,
  initializeDashboardFailed
} = filtersSlice.actions;

export default filtersSlice.reducer; 